import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { baseURL } from "../../../Util/axios_helper";
import { KendoGrid } from "../../../Kendo/kendo_grid";

const CustomerStatisfactionCards = ({year,type,filter,metric,metricvalue}) => {
  const dispatch = useDispatch();
  const { getReviewData } = useSelector((state) => state.reviews);
  const [googleReview, setgoogleReview] = useState(0);
  const [reviewfromwebmobile, setreviewfromwebmobile] = useState(0);
  const [testimonal, settestimonal] = useState(0);
  const [appplayreview, setappplayreview] = useState(0);
  const [backAgain, setbackAgain] = useState(0);
  const [referUs, setreferUs] = useState(0);

  const [webappflag, setwebappflag] = useState(false);
  const [GoogleReviewFlag, setGoogleReviewFlag] = useState(false);
  const [PlayAppFlag, setPlayAppFlag] = useState(false);
  const [title, settitle] = useState("");
  const [exportFName, setexportFName] = useState("");
  const [refreshflag, setrefreshflag] = useState(0);
  const [reportvalue, setreportvalue] = useState("");

  useEffect(() => {
    if (getReviewData && getReviewData.Table4Records) {
      const googleReview =
        getReviewData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "googlereview"
        )?.Count || 0;

      const reviewfromwebmobile =
        getReviewData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "reviewfromwebmobile"
        )?.Count || 0;

      const testimonal =
        getReviewData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "testimonal"
        )?.Count || 0;

      const appplayreview =
        getReviewData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "appplayreview"
        )?.Count || 0;

      const backAgain =
        getReviewData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "backagain"
        )?.Count || 0;

      const referUs =
        getReviewData.Table4Records.find(
          (item) => item.Type.trim().toLowerCase() === "referus"
        )?.Count || 0;

      setgoogleReview(googleReview);
      setreviewfromwebmobile(reviewfromwebmobile);
      settestimonal(testimonal);
      setappplayreview(appplayreview);
      setbackAgain(backAgain);
      setreferUs(referUs);
    }
  }, [getReviewData]);

  return (
    <>
      <div className="col-md-1  Widget-hover" title="View Google Review Report">
        <a
          href={`#`}
          onClick={() => {
            var modal = document.getElementById("CsModal");
            modal.style.display = "block";
            var span = document.getElementsByClassName("close")[0];
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
            setwebappflag(false);
            setPlayAppFlag(false);
            setGoogleReviewFlag(true);
            setreportvalue("googlereview");
            settitle("Google Review Report");
            setrefreshflag(refreshflag + 1);
            setexportFName("Google_Review_Report");
          }}
        >
          <div className="card dash-widget">
            <div className="card-body">
              <span className="dash-widget-icon">
                <i class="lab la-chrome"></i>{" "}
              </span>
              <div className="dash-widget-info">
                <h3>{googleReview}</h3>
                <span> Google Review</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div
        className="col-md-1  Widget-hover"
        title="View Review From Web/App Report"
      >
        <a
          href={`#`}
          onClick={() => {
            var modal = document.getElementById("CsModal");
            modal.style.display = "block";
            var span = document.getElementsByClassName("close")[0];
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
            setwebappflag(true);
            setGoogleReviewFlag(false);
            setPlayAppFlag(false);
            setreportvalue("reviewfromwebapp");
            settitle("Review From Web/App Report");
            setrefreshflag(refreshflag + 1);
            setexportFName("Review_From_Web/App_Report");
          }}
        >
          <div className="card dash-widget">
            <div className="card-body">
              <span className="dash-widget-icon">
                <i class="lab la-google"></i>{" "}
              </span>
              <div className="dash-widget-info">
                <h3>{reviewfromwebmobile}</h3>
                <span>Review From Web / App</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div className="col-md-1 Widget-hover" title="View Testimonial Report">
        <a
          href={`#`}
          onClick={() => {
            var modal = document.getElementById("CsModal");
            modal.style.display = "block";
            var span = document.getElementsByClassName("close")[0];
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
            setwebappflag(true);
            setGoogleReviewFlag(false);
            setPlayAppFlag(false);
            setreportvalue("testimonal");
            settitle("Testimonial Report");
            setrefreshflag(refreshflag + 1);
            setexportFName("Testimonial_Report");
          }}
        >
          <div className="card dash-widget">
            <div className="card-body">
              <span className="dash-widget-icon">
                <i class="las la-users"></i>{" "}
              </span>
              <div className="dash-widget-info">
                <h3>{testimonal}</h3>
                <span>Testimonial</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div
        className="col-md-1 Widget-hover"
        title="View Play/App Store Review Report"
      >
        <a
          href={`#`}
          onClick={() => {
            var modal = document.getElementById("CsModal");
            modal.style.display = "block";
            var span = document.getElementsByClassName("close")[0];
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
            setwebappflag(false);
            setGoogleReviewFlag(false);
            setPlayAppFlag(true);
            setreportvalue("playappstore");
            settitle("Play / App Store Review Report");
            setrefreshflag(refreshflag + 1);
            setexportFName("Play/App_Store_Review_Report");
          }}
        >
          <div className="card dash-widget">
            <div className="card-body">
              <span className="dash-widget-icon">
                <i class="las la-mobile-alt"></i>{" "}
              </span>
              <div className="dash-widget-info">
                <h3>{appplayreview}</h3>
                <span> Play / App Store Review</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div className="col-md-1 Widget-hover" title="View Back Again Report">
        <a
          href={`#`}
          onClick={() => {
            var modal = document.getElementById("CsModal");
            modal.style.display = "block";
            var span = document.getElementsByClassName("close")[0];
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
            setwebappflag(true);
            setGoogleReviewFlag(false);
            setPlayAppFlag(false);
            setreportvalue("backagain");
            settitle("Back Again Report");
            setrefreshflag(refreshflag + 1);
            setexportFName("Back_Again_Report");
          }}
        >
          <div className="card dash-widget">
            <div className="card-body">
              <span className="dash-widget-icon">
                <i class="las la-redo-alt"></i>{" "}
              </span>
              <div className="dash-widget-info">
                <h3>{backAgain}</h3>
                <span>Back Again</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div className="col-md-1 Widget-hover" title="View Refer Us Report">
        <a
          href={`#`}
          onClick={() => {
            var modal = document.getElementById("CsModal");
            modal.style.display = "block";
            var span = document.getElementsByClassName("close")[0];
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
            setwebappflag(true);
            setGoogleReviewFlag(false);
            setPlayAppFlag(false);
            setreportvalue("referus");
            settitle("Refer Us Report");
            setrefreshflag(refreshflag + 1);
            setexportFName("Refer_Us_Report");
          }}
        >
          <div className="card dash-widget">
            <div className="card-body">
              <span className="dash-widget-icon">
                <i class="las la-clone"></i>{" "}
              </span>
              <div className="dash-widget-info">
                <h3>{referUs}</h3>
                <span>Refer Us</span>
              </div>
            </div>
          </div>
        </a>
      </div>

      {/* <!-- Customer Satisfaction Report Modal --> */}
      <div id="CsModal" class="cmodal">
        <div class="cmodal-content">
          <div className="modal-header">
            <h5 className="modal-title-popup">{title}</h5>
            <span class="close" id="close">
              &times;
            </span>
          </div>
          <div className="row">
            <div className="col-md-12">
              {webappflag && !GoogleReviewFlag && !PlayAppFlag && (
                <KendoGrid
                  exportFileName={exportFName}
                  name={"webappflag_report"}
                  paggable={true}
                  url={`${baseURL}CustomerSatisfication/CustomerSatisfication_WebAppReport?type=${type}&years=${year}&filter=${filter}&metrics=${metric}&value=${metricvalue}&report=${reportvalue}`}
                  schema={{}}
                  refreshWhen={refreshflag}
                  columns={[
                    {
                      field: "EventNumber",
                      title: "Event Number",
                      width: 70,
                    },
                    {
                      field: "Name",
                      title: "Name",
                      width: 140,
                    },
                    {
                      field: "Phone",
                      title: "Phone No",
                      width: 130,
                    },
                    {
                      field: "Email",
                      title: "Email ID",
                      width: 200,
                    },
                    {
                      field: "Rating",
                      title: "Rating",
                      width: 80,
                    },
                    {
                      field: "ReviewComments",
                      title: "Review Comments",
                      width: 200,
                    },
                    {
                      field: "IsReferUs",
                      title: "Refer Us",
                      width: 90,
                      template: function (dataItem) {
                        return dataItem.IsReferUs ? "Yes" : "No";
                      },
                    },
                    {
                      field: "IsVisitAgain",
                      title: "Back Again",
                      width: 100,
                      template: function (dataItem) {
                        return dataItem.IsVisitAgain ? "Yes" : "No";
                      },
                    },
                    {
                      field: "ReviewDate",
                      title: "Review Date",
                      width: 120,
                    },
                  ]}
                  height={400}
                  showOptions={false}
                  showEdit={false}
                  showDelete={false}
                />
              )}
              {!webappflag && !GoogleReviewFlag && PlayAppFlag && (
                <KendoGrid
                  exportFileName={exportFName}
                  name={"PlayAppFlag_report"}
                  paggable={true}
                  url={`${baseURL}CustomerSatisfication/CustomerSatisfication_AppPlaystoreReport?type=${type}&years=${year}&filter=${filter}&metrics=${metric}&value=${metricvalue}&report=${reportvalue}`}
                  schema={{}}
                  refreshWhen={refreshflag}
                  columns={[
                    {
                      field: "EventNumber",
                      title: "Event Number",
                      width: 100,
                    },
                    {
                      field: "ReviewerName",
                      title: "Reviwer Name",
                      width: 120,
                    },
                    {
                      field: "Reviewercomment",
                      title: "Comments",
                      width: 250,
                    },
                    {
                      field: "StarRating",
                      title: "Star Rating",
                      width: 90,
                    },
                    {
                      field: "ReviewCreateDate",
                      title: "Review Date",
                      width: 110,
                    },
                    {
                      field: "Source",
                      title: "Source",
                      width: 90,
                    },
                  ]}
                  height={400}
                  showOptions={false}
                  showEdit={false}
                  showDelete={false}
                />
              )}
              {!webappflag && GoogleReviewFlag && !PlayAppFlag && (
                 <KendoGrid
                 exportFileName={exportFName}
                 name={"GoogleReviewFlag_report"}
                 paggable={true}
                 url={`${baseURL}CustomerSatisfication/CustomerSatisfication_GoogleReviewReport?type=${type}&years=${year}&filter=${filter}&metrics=${metric}&value=${metricvalue}&report=${reportvalue}`}
                 schema={{}}
                 refreshWhen={refreshflag}
                 columns={[
                   {
                     field: "EventNumber",
                     title: "Event Number",
                     width: 90,
                   },
                   {
                     field: "ReviewerName",
                     title: "Reviwer Name",
                     width: 110,
                   },
                   {
                     field: "ReviewerComments",
                     title: "Comments",
                     width: 250,
                   },
                   {
                     field: "StarRating",
                     title: "Star Rating",
                     width: 60,
                   },
                   {
                     field: "ReviewCreateTime",
                     title: "Review CreateTime",
                     width: 110,
                   },
                 ]}
                 height={400}
                 showOptions={false}
                 showEdit={false}
                 showDelete={false}
               />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <!-- End Customer Satisfaction Report Modal/ --> */}
    </>
  );
};

export default CustomerStatisfactionCards;
